import { jsx as m } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { $ as t } from "./index-D_37ItTm.js";
import { c as f } from "./index-SYE1cn5_.js";
const h = i(function({
  children: o,
  as: a = "h1",
  asChild: e = !1,
  variant: r = "display-1",
  className: s
}, c) {
  return /* @__PURE__ */ m(
    e ? t : a,
    {
      ref: c,
      className: f("heading", `heading--${r}`, s),
      children: o
    }
  );
});
export {
  h as H
};
